<script setup lang="ts">
import { nextTick, onMounted, ref, computed } from "vue"

const logoHeader = ref(0)
const navHeader = ref(0)
const navBar = ref(0)
const footerHeight = ref(0)

const detailContainerHeight = computed(() => {
  return `calc(100vh - ${logoHeader.value}px - ${navHeader.value}px - ${footerHeight.value}px - ${navBar.value}px)`
})

onMounted(() => {
  nextTick(() => {
    // offsetHeight if element has borders since clientHeight doesn't count it

    logoHeader.value = document.querySelector(".logo-header")?.clientHeight || 0
    navHeader.value = document.querySelector(".nav-header")?.offsetHeight || 0
    navBar.value = document.querySelector("#navbar")?.offsetHeight || 0
    footerHeight.value = document.querySelector("footer")?.clientHeight || 0
  })
})
</script>

<template>
  <div class="detail-container">
    <slot></slot>
  </div>
</template>

<style scoped>
.detail-container {
  height: v-bind(detailContainerHeight);
}
</style>
